import { render, staticRenderFns } from "./storeCouponsHistory.vue?vue&type=template&id=01b2646b&"
import script from "./storeCouponsHistory.vue?vue&type=script&lang=js&"
export * from "./storeCouponsHistory.vue?vue&type=script&lang=js&"
import style0 from "./storeCouponsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports